(function(Drupal, $, once){
    Drupal.behaviors.or18 = {
        attach: function( settings) {
            $(once('or18', 'body')).first().each(function(){
                var $or18 = $('.OR18__scrollable');
                var scrollableClass = '--scrollable';

                function run() {
                    $or18.each(function(){
                        $(this).parent().removeClass(scrollableClass);
                        if ($(this).get(0).scrollHeight > $(this).outerHeight() + 1) {
                            $(this).parent().addClass(scrollableClass);
                        }
                    });
                }

                run();

                // Accomodate for animations on mobile as they impact dimension calculation above.
                setTimeout(run, 500);

                $(window).resize(function(){
                    run();
                });
            });
        }
    }
})(Drupal, jQuery, once);
